<wuc-card
    cardStyle="tertiary"
    radius="medium"
    padding="medium"
    *ngIf="
        hasActivePurchasedProduct &&
        (hasCoveragesAdjustmentStartDate || hasRegularDriverFuture || hasRegularDriverEndDate)
    "
>
    <p *ngIf="hasCoveragesAdjustmentStartDate">
        Uw dekking per {{ purchasedProduct?.coverage?.coveragesAdjustmentStartDate | dateFormat }}:
        <br />
        <ins-insurance-list-coverages
            display="future"
            [purchasedProduct]="purchasedProduct"
        ></ins-insurance-list-coverages>
    </p>
    <p *ngIf="hasRegularDriverFuture">
        <span>
            Per {{ purchasedProduct?.productDetails?.regularDriverFuture?.startDate | dateFormat }} wijzigt uw
            regelmatige bestuurder.
        </span>
    </p>
    <p *ngIf="hasRegularDriverEndDate">
        <span>
            Per {{ purchasedProduct?.productDetails?.regularDriver?.endDate | dateFormat }} wijzigt uw regelmatige
            bestuurder.
        </span>
    </p>
</wuc-card>
